import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowLeftRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl, money } from "@/lib/api";

export default function TourCard({ tour }) {
  const { t } = useSite();
  return (
    <div className="tour-card group bg-white rounded-lg overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.08)] flex flex-col" data-testid={`tour-card-${tour.id}`}>
      <Link to={`/excursion/${tour.id}`} className="relative block h-[200px] overflow-hidden">
        <img src={mediaUrl(tour.image)} alt={tour.title} loading="lazy" className="w-full h-full object-cover" />
        {tour.offer && (
          <span className="absolute top-3 left-3 accent-bg text-[var(--accent-fg)] text-xs font-semibold px-3 py-1 rounded">{t("offer")}</span>
        )}
        <div className="absolute inset-0 bg-black/45 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="text-white font-semibold border-2 border-white rounded-md px-5 py-2 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
            {t("moreInfo")}
          </span>
        </div>
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex flex-wrap gap-2 mb-3">
          {(tour.locations || []).map((l) => (
            <span key={l} className="text-xs brand-text bg-[var(--brand)]/10 px-2 py-1 rounded">{l}</span>
          ))}
        </div>
        <Link to={`/excursion/${tour.id}`}>
          <h3 className="text-lg font-semibold text-gray-900 leading-snug hover:text-[var(--brand)] transition-colors">{tour.title}</h3>
        </Link>
        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mt-3">
          <span className="flex items-center gap-1"><Clock className="w-4 h-4" />{tour.duration}</span>
          <span className="flex items-center gap-1"><ArrowLeftRight className="w-4 h-4" />{tour.transport}</span>
        </div>
        <div className="mt-auto pt-5 flex items-end justify-between gap-3">
          <div>
            <div className="flex items-baseline gap-2">
              {tour.old_price ? <span className="text-sm text-gray-400 line-through">{money(tour.old_price)}</span> : null}
              <span className="text-2xl font-bold brand-text">{money(tour.price)}</span>
            </div>
            <div className="text-xs text-gray-500">{tour.price_unit}</div>
            {tour.extra_note && <div className="text-xs accent-text font-medium max-w-[120px]">{tour.extra_note}</div>}
          </div>
          <Link to={`/excursion/${tour.id}`} data-testid={`tour-pay-btn-${tour.id}`} className="btn-accent text-sm font-medium px-3.5 py-2 rounded text-center">
            {t("payNow")}
          </Link>
        </div>
      </div>
    </div>
  );
}
